import Registration from '../../components/registration/Registration';
import {
  createAccount,
  determineUserCountryByCountryCode,
  determineUserCountryByLanguage,
  determineUserCountryByLocation,
  setCountry,
  setEmail,
  setFirstName,
  setLastName,
  setPassword,
  setPhoneNumber,
  toggleEulaAcceptance,
  toggleShowPassword
} from 'actions/registrationActions';
import { trackConversion } from 'utils/analytics/googleTagManager';
import { getCountryCodeFromQueryParam } from 'utils/supportInfo';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export class RegistrationContainer extends React.Component {

  componentDidMount() {
    const countryCode = getCountryCodeFromQueryParam() ||
      localStorage.getItem('referrerCountryCode');
    if (countryCode) {
      this.props.determineUserCountryByCountryCode(countryCode);
    } else {
      this.props.determineUserCountryByLanguage();
    }

    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.props.determineUserCountryByLocation(position.coords);
      });
    }
    trackConversion();
  }

  setEmailValue = (event) => {
    this.props.setEmail(event.target.value || '');
  }

  setFirstNameValue = (event) => {
    this.props.setFirstName(event.target.value || '');
  }

  setLastNameValue = (event) => {
    this.props.setLastName(event.target.value || '');
  }

  setPasswordValue = (event) => {
    this.props.setPassword(event.target.value || '');
  }

  setPhoneNumberValue = (event) => {
    this.props.setPhoneNumber(event.target.value || '');
  }

  render() {
    const {
      apiErrorText,
      country,
      email,
      emailErrorText,
      eulaErrorText,
      eulaLink,
      firstName,
      firstNameErrorText,
      isEulaAccepted,
      isRegistrationFetching,
      isShowingPassword,
      lastName,
      lastNameErrorText,
      password,
      passwordErrorText,
      phoneNumber,
      phoneNumberErrorText,
      ppLink
    } = this.props;

    return (
      <Registration
        apiErrorText={apiErrorText}
        country={country}
        createAccount={this.props.createAccount}
        email={email}
        emailErrorText={emailErrorText}
        eulaErrorText={eulaErrorText}
        eulaLink={eulaLink}
        firstName={firstName}
        firstNameErrorText={firstNameErrorText}
        isEulaAccepted={isEulaAccepted}
        isRegistrationFetching={isRegistrationFetching}
        isShowingPassword={isShowingPassword}
        lastName={lastName}
        lastNameErrorText={lastNameErrorText}
        password={password}
        passwordErrorText={passwordErrorText}
        phoneNumber={phoneNumber}
        phoneNumberErrorText={phoneNumberErrorText}
        ppLink={ppLink}
        setCountry={this.props.setCountry}
        setEmail={this.setEmailValue}
        setFirstName={this.setFirstNameValue}
        setLastName={this.setLastNameValue}
        setPassword={this.setPasswordValue}
        setPhoneNumber={this.setPhoneNumberValue}
        toggleEulaAcceptance={this.props.toggleEulaAcceptance}
        toggleShowPassword={this.props.toggleShowPassword} />
    );
  }
}

RegistrationContainer.propTypes = {
  // Text describing any errors on the inputs
  apiErrorText: PropTypes.string.isRequired,

  // User's selected country
  country: PropTypes.string,

  // Request registration / account creation API to be called
  createAccount: PropTypes.func.isRequired,

  // Determine the user's country using countryCode
  determineUserCountryByCountryCode: PropTypes.func.isRequired,

  // Determine the user's country
  determineUserCountryByLanguage: PropTypes.func.isRequired,

  // Determine user's country using navigator.geolocation
  determineUserCountryByLocation: PropTypes.func.isRequired,

  // User's inputed email
  email: PropTypes.string.isRequired,

  // Text describing any email-specific errors
  emailErrorText: PropTypes.string.isRequired,

  // Text describing any EULA errors
  eulaErrorText: PropTypes.string.isRequired,

  // URL for EULA of currently selected country
  eulaLink: PropTypes.string.isRequired,

  // User's inputed first name
  firstName: PropTypes.string.isRequired,

  // Text describing any firstName-specific errors
  firstNameErrorText: PropTypes.string.isRequired,

  // Boolean defining whether the user accepted the EULA or not
  isEulaAccepted: PropTypes.bool.isRequired,

  // Boolean that determines if the request to register is in progress
  isRegistrationFetching: PropTypes.bool.isRequired,

  // Boolean that determines whether to show or hide the user's password
  isShowingPassword: PropTypes.bool.isRequired,

  // User's inputed last name
  lastName: PropTypes.string.isRequired,

  // Text describing any lastName-specific errors
  lastNameErrorText: PropTypes.string.isRequired,

  // User's inputed password
  password: PropTypes.string.isRequired,

  // Text describing any password-specific errors
  passwordErrorText: PropTypes.string.isRequired,

  // User's inputed phone number
  phoneNumber: PropTypes.string.isRequired,

  // Text describing any phone number-specific errors
  phoneNumberErrorText: PropTypes.string.isRequired,

  // URL for the Privacy Policy of currently selected country
  ppLink: PropTypes.string.isRequired,

  // Click handler that sets the user's country
  setCountry: PropTypes.func.isRequired,

  // Emails's textinput's onChange function
  setEmail: PropTypes.func.isRequired,

  // First name's textinput's onChange function
  setFirstName: PropTypes.func.isRequired,

  // Last name's textinput's onChange function
  setLastName: PropTypes.func.isRequired,

  // Password's textinput's onChange function
  setPassword: PropTypes.func.isRequired,

  // Phone number's textinput's onChange function
  setPhoneNumber: PropTypes.func.isRequired,

  // Click handler that toggles the isEulaAccepted boolean
  toggleEulaAcceptance: PropTypes.func.isRequired,

  // Click handler function that toggles the isShowingPassword boolean
  toggleShowPassword: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    apiErrorText: state.registration.apiErrorText,
    country: state.registration.country,
    email: state.registration.email,
    emailErrorText: state.registration.emailErrorText,
    eulaErrorText: state.registration.eulaErrorText,
    eulaLink: state.registration.eulaLink,
    firstName: state.registration.firstName,
    firstNameErrorText: state.registration.firstNameErrorText,
    isEulaAccepted: state.registration.isEulaAccepted,
    isRegistrationFetching: state.registration.isFetching,
    isShowingPassword: state.registration.isShowingPassword,
    lastName: state.registration.lastName,
    lastNameErrorText: state.registration.lastNameErrorText,
    missingInputsList: state.registration.missingInputsList,
    password: state.registration.password,
    passwordErrorText: state.registration.passwordErrorText,
    phoneNumber: state.registration.phoneNumber,
    phoneNumberErrorText: state.registration.phoneNumberErrorText,
    ppLink: state.registration.ppLink
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      createAccount,
      determineUserCountryByCountryCode,
      determineUserCountryByLanguage,
      determineUserCountryByLocation,
      setCountry,
      setEmail,
      setFirstName,
      setLastName,
      setPassword,
      setPhoneNumber,
      toggleEulaAcceptance,
      toggleShowPassword
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationContainer);